import { render } from "./invitation.vue?vue&type=template&id=afac657c&scoped=true"
import script from "./invitation.vue?vue&type=script&lang=js"
export * from "./invitation.vue?vue&type=script&lang=js"

import "./invitation.vue?vue&type=style&index=0&id=afac657c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afac657c"],['__file',"src/views/user_center/components/invitation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "afac657c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('afac657c', __exports__)) {
    api.reload('afac657c', __exports__)
  }
  
  module.hot.accept("./invitation.vue?vue&type=template&id=afac657c&scoped=true", () => {
    api.rerender('afac657c', render)
  })

}


export default __exports__